import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { BiFilterAlt } from 'react-icons/bi';
import Select from 'react-select';
import axios from 'axios';

const FiltreEntente = ({ onFilter }) => {
    const [showExtraFilters, setShowExtraFilters] = useState(false);
    const [filters, setFilters] = useState({
        ententeId: '',
        dateDebut: '',
        css: '',
        activite: '',
        fournisseur: '',
        client: '',
        contact: '',
        contexte: '',
        tel: '',
        thematique: '',
        produit: '',
        statut: '',
    });

    interface Options {
        value: string;
        label: string;
    }

    const [cssOptions, setCssOptions] = useState<Options[]>([]);
    const [contactOptions, setContactOptions] = useState<Options[]>([]);
    const [activiteOptions, setActiviteOptions] = useState<Options[]>([]);
    const [fournisseurOptions, setFournisseurOptions] = useState<Options[]>([]);
    const [clientOptions, setClientOptions] = useState<Options[]>([]);
    const [thematiqueOptions, setThematiqueOptions] = useState<Options[]>([]);
    const [produitOptions, setProduitOptions] = useState<Options[]>([]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (selectedOption, field) => {
        setFilters((prev) => ({
            ...prev,
            [field]: selectedOption ? selectedOption.value : '',
        }));
    };

    useEffect(() => {
        const init = async () => {
            let response = await axios.get('../../api/centres-service-scolaire');
            setCssOptions(response.data.map((css) => ({ value: css.abbr, label: css.abbr })));
            response = await axios.get('../../api/contacts');
            setContactOptions(response.data.map((contact) => ({ value: contact.name, label: contact.name })));
            response = await axios.get('../../api/activites');
            setActiviteOptions(response.data.map((activite) => ({ value: activite.name, label: activite.name })));
            response = await axios.get('../../api/fournisseurs');
            setFournisseurOptions(
                response.data.map((fournisseur) => ({ value: fournisseur.name, label: fournisseur.name })),
            );
            response = await axios.get('../../api/clients');
            setClientOptions(response.data.map((client) => ({ value: client.name, label: client.name })));
            response = await axios.get('../../api/thematique');
            setThematiqueOptions(
                response.data.map((thematique) => ({ value: thematique.name, label: thematique.name })),
            );
            response = await axios.get('../../api/produits');
            setProduitOptions(response.data.map((produit) => ({ value: produit.name, label: produit.name })));
        };

        init();
    }, []);

    return (
        <>
            <Row className="mb-2">
                <Col md={10}>
                    <Row>
                        <Col md={4}>
                            <Form.Control
                                size="sm"
                                type="number"
                                placeholder="# Entente"
                                name="ententeId"
                                value={filters.ententeId}
                                onChange={handleChange}
                                style={{ height: '37px' }}
                            />
                        </Col>
                        <Col md={4}>
                            <Select
                                placeholder="CSS"
                                options={cssOptions}
                                value={cssOptions.find((option) => option.value === filters.css) || null}
                                onChange={(selectedOption) => handleSelectChange(selectedOption, 'css')}
                                isClearable
                            />
                        </Col>
                        <Col md={4}>
                            <Select
                                placeholder="Nom d'un contact"
                                options={contactOptions}
                                value={contactOptions.find((option) => option.value === filters.contact) || null}
                                onChange={(selectedOption) => handleSelectChange(selectedOption, 'contact')}
                                isClearable
                            />
                        </Col>
                    </Row>

                    <Row className="mt-2">
                        <Col md={4}>
                            <Select
                                placeholder="Nom de l'activité"
                                options={activiteOptions}
                                value={activiteOptions.find((option) => option.value === filters.activite) || null}
                                onChange={(selectedOption) => handleSelectChange(selectedOption, 'activite')}
                                isClearable
                            />
                        </Col>
                        <Col md={4}>
                            <Select
                                placeholder="Nom du fournisseur"
                                options={fournisseurOptions}
                                value={
                                    fournisseurOptions.find((option) => option.value === filters.fournisseur) || null
                                }
                                onChange={(selectedOption) => handleSelectChange(selectedOption, 'fournisseur')}
                                isClearable
                            />
                        </Col>
                        <Col md={4}>
                            <Select
                                placeholder="Nom du client"
                                options={clientOptions}
                                value={clientOptions.find((option) => option.value === filters.client) || null}
                                onChange={(selectedOption) => handleSelectChange(selectedOption, 'client')}
                                isClearable
                            />
                        </Col>
                    </Row>

                    {showExtraFilters && (
                        <>
                            <hr />
                            <Row className="mt-2">
                                <Col md={4}>
                                    <Form.Control
                                        size="sm"
                                        type="date"
                                        name="dateDebut"
                                        value={filters.dateDebut}
                                        onChange={handleChange}
                                        style={{ height: '37px' }}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Select
                                        placeholder="Nom du produit"
                                        options={produitOptions}
                                        value={
                                            produitOptions.find((option) => option.value === filters.produit) || null
                                        }
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, 'produit')}
                                        isClearable
                                    />
                                </Col>
                                <Col md={4}>
                                    <Select
                                        placeholder="Thématique"
                                        options={thematiqueOptions}
                                        value={
                                            thematiqueOptions.find((option) => option.value === filters.thematique) ||
                                            null
                                        }
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, 'thematique')}
                                        isClearable
                                    />
                                </Col>
                            </Row>

                            <Row className="mt-2">
                                <Col md={4}>
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        placeholder="Contexte"
                                        name="contexte"
                                        value={filters.contexte}
                                        onChange={handleChange}
                                        style={{ height: '37px' }}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        placeholder="Statut"
                                        name="statut"
                                        value={filters.statut}
                                        onChange={handleChange}
                                        style={{ height: '37px' }}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Form.Control
                                        size="sm"
                                        type="tel"
                                        placeholder="# Téléphone d'un contact"
                                        name="tel"
                                        value={filters.tel}
                                        onChange={handleChange}
                                        style={{ height: '37px' }}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}
                </Col>

                <Col md={2} className="d-flex flex-column align-items-end justify-content-start">
                    <Button
                        variant="primary"
                        size="sm"
                        className="mb-2"
                        onClick={() => onFilter(filters)}
                        style={{ height: '37px' }}
                    >
                        <BiFilterAlt /> Filtrer
                    </Button>
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => setShowExtraFilters(!showExtraFilters)}
                        style={{ height: '37px' }}
                    >
                        {showExtraFilters ? 'Masquer les filtres' : 'Afficher tous les filtres'}
                    </Button>
                </Col>
            </Row>
        </>
    );
};

export default FiltreEntente;
